import { Buffer } from 'buffer';

const timerId = new Map<string, NodeJS.Timeout>();

export async function debouncePromise<T>(fn: () => Promise<T>, time: number): Promise<T> {
    const hash = Buffer.from(fn.toString()).toString('base64');

    if (timerId.has(hash)) {
        clearTimeout(timerId.get(hash));
    }

    return new Promise<T>((resolve) => {
        timerId.set(
            hash,
            setTimeout(() => resolve(fn()), time),
        );
    });
}
